module.exports = __webpack_public_path__ + "static/img/step1.59605803.png";